function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMchd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 128 128",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m125.1 70.5-23-9.3c-.7-.3-1.5-.3-2.2 0l-23 9.3c-1.2.4-1.9 1.5-1.9 2.8v17.7c0 20.1 8.8 26.3 24.5 35.6.5.3 1 .4 1.5.4s1.1-.1 1.5-.4c15.6-9.3 24.5-15.5 24.5-35.6v-17.7c0-1.3-.7-2.4-1.9-2.8zm-4.1 20.5c0 15.6-5.5 20.8-20 29.5-14.5-8.7-20-13.9-20-29.5v-15.7l20-8.1 20 8.1z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106 50c1.7 0 3-1.3 3-3v-18c0-6.1-2.4-11.9-6.7-16.3s-10.2-6.7-16.3-6.7h-54c-7.2 0-13 5.8-13 13v90c0 7.2 5.8 13 13 13h40c1.7 0 3-1.3 3-3s-1.3-3-3-3h-40c-3.9 0-7-3.1-7-7v-90c0-3.9 3.1-7 7-7h51v7c0 7.2 5.8 13 13 13h7v15c0 1.7 1.3 3 3 3zm-17-31v-6.7c3.4.6 6.5 2.2 9 4.7s4.1 5.6 4.7 9h-6.7c-3.9 0-7-3.1-7-7z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMchd);
export default __webpack_public_path__ + "static/media/mchd.300c119860015e67c925a078c21a2b0c.svg";
export { ForwardRef as ReactComponent };